import { useState } from 'react'
import DownIcon from 'assets/images/rectangle/down1.svg'
import UpIcon from 'assets/images/rectangle/up1.svg'
import DeleteIcon from 'assets/images/deletes/delete-black-1.png'
import useDeleteSettlement from '../hooks/useDeleteSettlement'
interface iItemProps {
    item: ISettlementsResult
    refetch: () => void
}

export default function Item({ item, refetch }: iItemProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const { isLoading, mutate } = useDeleteSettlement(refetch)
    return (
        <div
            className=" py-2 px-2 bg-white my-2 mx-2 rounded-md shadow-[4px_4px_25px__rgba(0,0,0,0.1)] transition-all"
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className=" flex justify-between">
                <div>{item.requesting_user_name}</div>
                <div className=" flex">
                    <p className=" text-sm text-gray-4 bg-error-4 px-2 py-0.5 rounded-full mx-2">
                        {item.status === null
                            ? 'در حال بررسی'
                            : item.status === 'rjc'
                            ? 'رد شده'
                            : 'پذیرفته شده'}
                    </p>
                    <img src={isOpen ? UpIcon : DownIcon} alt="down-up" />
                </div>
            </div>
            <p className=" text-sm">{item.discription}</p>
            {isOpen && (
                <div className=" flex justify-center ">
                    <img
                        src={DeleteIcon}
                        alt="delete"
                        className=" w-10 h-10 py-2 px-2 rounded-md bg-error-4"
                        onClick={(event) => {
                            event.stopPropagation()
                            !isLoading && mutate(item.moneypool)
                        }}
                    />
                </div>
            )}
        </div>
    )
}
